/// <amd-module name="Tfs/Frame/Components/Navigation/SwitchToDesktopButton" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";

import { IconSize } from "VSSUI/Icon";
import { css } from "VSSUI/Util";

import { ISwitchToDesktopProps } from "TFS/Mobile/Components/SwitchToDesktop.Props";

export interface ISwitchToDesktopButtonProps extends Pick<ISwitchToDesktopProps, "className" | "iconClassName" | "textClassName"> {
    context: IVssComponentContext;
}

/**
 * Gets the switch to desktop navigation action if the page supports mobile view.
 * If mobile view is not supported, returns null.
 *
 * If mobile is not supported,
 *
 * @param pageContext Page context.
 */
export const SwitchToDesktopButton = (props: ISwitchToDesktopButtonProps): JSX.Element | null => {
    // Determine whether switch to desktop contribution is added to page.
    // If not added, there is no need to render the button which means page does not support mobile view or mobile view is disabled.
    const contributionService = props.context.pageContext.getService<IVssContributionService>("IVssContributionService");
    const switchToDesktopProps = contributionService.getContribution("ms.vss-tfs-web.switch-to-desktop") as ISwitchToDesktopProps;

    return switchToDesktopProps ? (
        <WrappedComponent<ISwitchToDesktopProps>
            dependencies={["ms.vss-tfs-web.mobile-content"]}
            wrappedProps={{
                ariaLabel: switchToDesktopProps.ariaLabel,
                className: css(switchToDesktopProps.className, props.className),
                iconClassName: css(switchToDesktopProps.iconClassName, props.iconClassName),
                iconProps: { ...switchToDesktopProps.iconProps, size: IconSize.medium },
                text: switchToDesktopProps.text,
                textClassName: css(switchToDesktopProps.textClassName, props.textClassName)
            }}
            wrappedType="ms.vss-tfs-web.switchToDesktopCommand"
        />
    ) : null;
};
